import React, { FC } from 'react';
import Image from 'next/image';
import CloudinaryResponsiveImage from '../CloudinaryResponsiveImage/CloudinaryResponsiveImage';
import { DEFAULT_ARTICLE_IMAGE } from '../ArticleCard/constants';
import Typo from '../Typography/Typo';
import { getMultilineEllipsisStyle } from '../PromptCard/utils/getMultilineEllipsisStyle';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';

type TArticleParentInfoDetailsProps = {
  parentTitle: string;
  parentAuthor: string;
  image?: TCloudinaryImageShape | undefined;
  deactivated?: boolean;
};

export const ArticleParentInfoDetails: FC<TArticleParentInfoDetailsProps> = ({
  image,
  parentTitle,
  parentAuthor,
  deactivated,
}) => {
  if ((!parentAuthor && !parentTitle) || deactivated) {
    return null;
  }

  return (
    <div className="mt-4 flex items-center gap-2">
      <div className="h-10 max-w-10 rounded-[7px]">
        {image ? (
          <CloudinaryResponsiveImage
            aspectRatio={1}
            image={image}
            alt="article image"
            className="h-10 min-w-10 object-cover rounded-[7px]"
            containerClassName="w-10"
          />
        ) : (
          <Image
            priority
            src={DEFAULT_ARTICLE_IMAGE}
            className="h-10 min-w-10 object-cover rounded-[7px]"
            width={40}
            height={40}
            alt="post image"
          />
        )}
      </div>
      <div className="w-full flex flex-col items-start">
        <Typo
          variant="small-p"
          className="md:max-w-[50%] !text-sm text-t2-neutral-grey09 !font-semibold multiline-ellipsis"
          style={getMultilineEllipsisStyle(1)}
        >
          {parentTitle}
        </Typo>
        <Typo variant="small-p" className="!text-xs text-left">
          By {parentAuthor}
        </Typo>
      </div>
    </div>
  );
};
